<template>
  <div>
    <div>
      <div class="max-w-5xl mx-auto">
        <div
          class="flex flex-wrap items-center justify-between -mt-2 -ml-4 sm:flex-no-wrap"
        >
          <div class="mt-2 ml-4">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Categorie
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-600">
              Utilizza le categorie per organizzare al meglio il tuo menu.
              Trascina le categorie per riordinarle.
            </p>
          </div>
          <div class="flex-shrink-0 mt-2 ml-4">
            <span class="inline-flex rounded-md shadow-sm">
              <router-link
                :to="{ name: 'CategoryCreate', params: { id: this.id } }"
                type="button"
                class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
              >
                Crea nuova
              </router-link>
            </span>
          </div>
        </div>
      </div>

      <div class="max-w-5xl mx-auto mt-5">
        <div class="flex flex-col">
          <div
            class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
          >
            <div
              class="inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow sm:rounded-lg"
            >
              <table class="min-w-full">
                <thead>
                  <tr>
                    <th
                      class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                    >
                      Nome
                    </th>

                    <th
                      class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 sm:table-cell bg-gray-50"
                    >
                      Numero Piatti<span class="text-xs">*</span>
                    </th>
                    <th
                      class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 lg:table-cell bg-gray-50"
                    >
                      Prezzo medio<span class="text-xs">*</span>
                    </th>
                    <th
                      class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 lg:table-cell bg-gray-50"
                    >
                      Minimo<span class="text-xs">*</span>
                    </th>
                    <th
                      class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 lg:table-cell bg-gray-50"
                    >
                      Massimo
                    </th>
                    <th
                      class="px-6 py-3 border-b border-gray-200 bg-gray-50"
                    ></th>
                  </tr>
                </thead>
                <draggable
                  :options="options"
                  v-model="categories"
                  :disabled="disabled"
                  @update="onDraggableUpdate"
                  tag="tbody"
                  class="bg-white"
                >
                  <router-link
                    class="cursor-pointer hover:bg-gray-50 "
                    :to="{ name: 'Dishes', hash: '#cat' + category.id }"
                    v-for="category in categories"
                    :key="category.id"
                    tag="tr"
                  >
                    <td class="px-6 py-4 border-b border-gray-200">
                      <div class="flex items-center">
                        <div class="flex-shrink-0 w-10 h-10">
                          <img
                            v-if="category.url != null"
                            :src="getCategoryIcon(category.url)"
                            class="w-10 h-10"
                            :alt="category.name"
                          />
                          <div v-else class="w-10 h-10 rounded-full">
                            <svg
                              class="w-10 h-10"
                              viewBox="0 0 512 512"
                              xmlns="http://www.w3.org/2000/svg"
                              height="512"
                              width="512"
                            >
                              <g clip-rule="evenodd" fill-rule="evenodd">
                                <path
                                  d="M256 66c104.934 0 190 85.066 190 190s-85.066 190-190 190S66 360.934 66 256 151.066 66 256 66zm246 190c0-135.862-110.138-246-246-246S10 120.138 10 256s110.138 246 246 246 246-110.138 246-246z"
                                  fill="#fff"
                                  data-original="#FFF"
                                />
                                <path
                                  d="M445.999 256c0-104.934-85.066-190-190-190C151.066 66 66 151.066 66 256s85.066 190 190 190c104.933 0 189.999-85.066 189.999-190zm-172.062-58.794c0-27.614 20.147-67.362 45-67.362s45 39.747 45 67.362c0 19.632-10.183 32.9-25 38.928v126.023c0 11-9 20-20 20s-20-9-20-20v-126.02c-14.817-6.031-25-19.299-25-38.931zm-61.75 47.245v117.706c0 10.999-9 20-20 20s-20-9-20-20V244.45c-11.933-6.942-20-19.877-20-34.605v-9.999h80v9.999c0 14.727-8.066 27.663-20 34.606z"
                                  fill="#fff"
                                  data-original="#FFF"
                                />
                                <path
                                  d="M212.187 244.45c11.934-6.942 20-19.878 20-34.605v-9.999h-80v9.999c0 14.728 8.066 27.663 20 34.605a39.662 39.662 0 0020 5.395 39.66 39.66 0 0020-5.395z"
                                  fill="#c3dafe"
                                  data-original="#C3DAFE"
                                  data-old_color="#b6bccf"
                                />
                                <path
                                  d="M212.187 362.157V244.451c-5.892 3.428-12.728 5.395-20 5.395s-14.108-1.967-20-5.395v117.706c0 11 9 20 20 20 11-.001 20-9.001 20-20z"
                                  fill="#5850ec"
                                  data-original="#5850EC"
                                  data-old_color="#ff764e"
                                />
                                <path
                                  d="M273.937 197.206c0 19.632 10.183 32.9 25 38.931 6.025 2.452 12.816 3.708 20 3.708s13.975-1.255 20-3.708c14.817-6.031 25-19.299 25-38.931 0-27.614-20.147-67.362-45-67.362s-45 39.748-45 67.362z"
                                  fill="#c3dafe"
                                  data-original="#C3DAFE"
                                  data-old_color="#b6bccf"
                                />
                                <path
                                  d="M298.937 236.134v126.023c0 11 9 20 20 20s20-9 20-20v-126.02c-6.025 2.452-12.816 3.708-20 3.708-7.184-.001-13.975-1.256-20-3.711z"
                                  fill="#5850ec"
                                  data-original="#5850EC"
                                  data-old_color="#ff764e"
                                />
                              </g>
                              <path
                                d="M256 0C114.841 0 0 114.841 0 256s114.841 256 256 256 256-114.841 256-256S397.159 0 256 0zm0 492C125.869 492 20 386.131 20 256S125.869 20 256 20s236 105.869 236 236-105.869 236-236 236z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#414141"
                              />
                              <path
                                d="M256 56c-61.174 0-118.174 27.455-156.385 75.324-3.445 4.317-2.739 10.609 1.577 14.054s10.608 2.739 14.054-1.577C149.64 100.713 200.943 76 256 76c99.252 0 180 80.748 180 180s-80.748 180-180 180S76 355.252 76 256c0-11.934 1.175-23.867 3.493-35.468 1.082-5.416-2.431-10.683-7.847-11.765-5.41-1.083-10.683 2.431-11.765 7.847A201.39 201.39 0 0056 256c0 110.28 89.72 200 200 200s200-89.72 200-200S366.28 56 256 56z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#414141"
                              />
                              <path
                                d="M152.187 129.844c-5.523 0-10 4.477-10 10v70.001c0 16.323 7.864 30.841 20 39.972v112.339c0 16.542 13.458 30 30 30s30-13.458 30-30V249.818c12.136-9.131 20-23.65 20-39.973v-70.001c0-5.523-4.477-10-10-10s-10 4.477-10 10v50.002h-20v-50.002c0-5.523-4.477-10-10-10s-10 4.477-10 10v50.002h-20v-50.002c0-5.523-4.477-10-10-10zm50 232.313c0 5.514-4.486 10-10 10s-10-4.486-10-10V258.839c3.232.659 6.576 1.006 10 1.006s6.768-.347 10-1.006zm-10-122.312c-16.542 0-29.999-13.458-30-29.999l60-.001c0 16.542-13.458 30-30 30zM318.937 392.156c16.542 0 30-13.458 30-30V242.324c15.496-8.888 25-25.036 25-45.118 0-15.76-5.472-34.165-14.636-49.232-11.033-18.139-25.368-28.129-40.364-28.129s-29.331 9.99-40.364 28.129c-9.165 15.068-14.636 33.473-14.636 49.232 0 20.083 9.504 36.231 25 45.118v119.833c0 16.542 13.458 29.999 30 29.999zm10-29.999c0 5.514-4.486 10-10 10s-10-4.486-10-10v-113.05a68.038 68.038 0 0020 0zm-10-222.313c7.633 0 16.117 6.751 23.276 18.522 7.232 11.889 11.724 26.772 11.724 38.839 0 24.065-18.08 32.639-35 32.639s-35-8.574-35-32.639c0-23.988 17.637-57.361 35-57.361zM83.698 185.802h.007c5.523 0 9.997-4.477 9.997-10s-4.481-10-10.004-10-10 4.477-10 10 4.477 10 10 10z"
                                data-original="#000000"
                                class="active-path"
                                data-old_color="#000000"
                                fill="#414141"
                              />
                            </svg>
                          </div>
                        </div>
                        <div class="ml-4">
                          <div
                            class="text-sm font-medium leading-5 text-gray-900"
                          >
                            {{ category.name }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td
                      class="hidden px-6 py-4 whitespace-no-wrap border-b border-gray-200 sm:table-cell"
                    >
                      <span
                        v-if="category.ndishes"
                        class="inline-flex px-2 text-xs font-semibold leading-5 text-teal-800 bg-teal-100 rounded-full"
                      >
                        {{ category.ndishes }}
                      </span>
                      <span
                        v-else
                        class="inline-flex px-2 text-xs font-semibold leading-5 text-teal-800 bg-teal-100 rounded-full"
                      >
                        0
                      </span>
                    </td>
                    <td
                      class="hidden px-6 py-4 whitespace-no-wrap border-b border-gray-200 lg:table-cell"
                    >
                      <div
                        class="text-sm leading-5 text-gray-900"
                        v-if="category.avg"
                      >
                        <span
                          v-if="
                            category.avg != null &&
                              category.avg != undefined &&
                              category.avg != ''
                          "
                          class="inline-flex items-center px-2 text-xs font-medium leading-5 text-blue-700 bg-blue-100 rounded-md "
                        >
                          {{ category.avg.toFixed(2) }} €
                        </span>
                      </div>
                    </td>
                    <td
                      class="hidden px-6 py-4 whitespace-no-wrap border-b border-gray-200 lg:table-cell"
                    >
                      <div
                        class="text-sm leading-5 text-gray-900"
                        v-if="category.min"
                      >
                        <span
                          v-if="
                            category.min != null &&
                              category.min != undefined &&
                              category.min != ''
                          "
                          class="inline-flex items-center px-2 text-xs font-medium leading-5 text-indigo-700 bg-indigo-100 rounded-md "
                        >
                          {{ category.min.toFixed(2) }} €
                        </span>
                      </div>
                    </td>
                    <td
                      class="hidden px-6 py-4 whitespace-no-wrap border-b border-gray-200 lg:table-cell"
                    >
                      <div
                        class="text-sm leading-5 text-gray-900"
                        v-if="category.max"
                      >
                        <span
                          v-if="
                            category.max != null &&
                              category.max != undefined &&
                              category.max != ''
                          "
                          class="inline-flex items-center px-2 text-xs font-medium leading-5 text-purple-700 bg-purple-100 rounded-md "
                        >
                          {{ category.max.toFixed(2) }} €
                        </span>
                      </div>
                    </td>

                    <td
                      class="px-6 py-4 text-sm font-medium leading-5 text-right whitespace-no-wrap border-b border-gray-200"
                    >
                      <!--
                      <router-link 
                        class="text-indigo-600 hover:text-indigo-900"
                        :to="{ name: 'Category', params:{ id: id, idcategory: category.id }}">
                        Modifica
                      </router-link>
                      -->
                      <div class="relative inline-block text-left">
                        <div>
                          <span class="rounded-md shadow-sm">
                            <router-link
                              :to="{
                                name: 'Category',
                                params: { id: id, idcategory: category.id },
                              }"
                              type="button"
                              class="inline-flex justify-center w-full px-2 py-1 text-xs font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 hover:bg-gray-100"
                              id="options-menu"
                              aria-haspopup="true"
                              aria-expanded="true"
                            >
                              Modifica
                            </router-link>
                          </span>
                        </div>
                      </div>
                    </td>
                  </router-link>
                </draggable>
              </table>
              <div v-if="showEmpty">
                <div
                  class="inline-block min-w-full p-5 overflow-hidden text-center align-middle bg-white"
                >
                  <div class="mx-auto">
                    <div
                      class="flex items-center justify-center flex-shrink-0 mx-auto rounded-full"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 286.001 286"
                        class="w-12 h-12"
                      >
                        <defs>
                          <linearGradient
                            id="categoryb"
                            x1=".089"
                            y1=".068"
                            x2=".908"
                            y2=".94"
                            gradientUnits="objectBoundingBox"
                          >
                            <stop offset="0" stop-color="#a9f651"></stop>
                            <stop offset=".372" stop-color="#58e256"></stop>
                            <stop offset="1" stop-color="#03cc5b"></stop>
                          </linearGradient>
                          <filter
                            id="categorya"
                            x="0"
                            y="0"
                            width="286.001"
                            height="286"
                            filterUnits="userSpaceOnUse"
                          >
                            <feOffset dx="8" dy="15"></feOffset>
                            <feGaussianBlur
                              stdDeviation="5"
                              result="blur"
                            ></feGaussianBlur>
                            <feFlood flood-opacity=".161"></feFlood>
                            <feComposite operator="in" in2="blur"></feComposite>
                            <feComposite in="SourceGraphic"></feComposite>
                          </filter>
                        </defs>
                        <g filter="url(#categorya)">
                          <path
                            data-name="dasch_cloche2"
                            d="M233 256H23a23 23 0 01-23-23V23A23 23 0 0123 0h210a23 23 0 0123 23v210a23 23 0 01-23 23zM30.826 46.642a7.466 7.466 0 00-7.474 7.441v148.834a7.467 7.467 0 007.474 7.442h194.348a7.467 7.467 0 007.475-7.442V83.85a7.467 7.467 0 00-7.475-7.442H128L95.111 46.642zM189.352 194H66.5a12.654 12.654 0 01-10.541-5.617 23.822 23.822 0 01-4.046-13.3v-3.16a3.164 3.164 0 013.167-3.153h145.691a3.164 3.164 0 013.167 3.153v3.16a23.831 23.831 0 01-4.043 13.293A12.661 12.661 0 01189.352 194zm.648-31.531H65.85a3.159 3.159 0 01-3.105-3.782 66.388 66.388 0 0156.484-52.342 9.32 9.32 0 01-.807-3.786 9.5 9.5 0 0119 0 9.319 9.319 0 01-.806 3.786 66.387 66.387 0 0156.484 52.342 3.159 3.159 0 01-3.1 3.782zm-84.261-39.064a3.16 3.16 0 00-1.394.323 53.674 53.674 0 00-23.055 21.395 3.142 3.142 0 001.154 4.307 3.172 3.172 0 004.327-1.148 47.423 47.423 0 0120.352-18.888 3.153 3.153 0 00-1.383-5.989z"
                            transform="translate(7)"
                            fill="url(#categoryb)"
                          ></path>
                        </g>
                      </svg>
                    </div>
                  </div>

                  <p class="mt-1 text-base">
                    Non sono presenti categorie, creane una adesso!
                  </p>
                  <!--
                  <router-link :to="{ name : 'CategoryCreate',  params : { id: this.id }}" type="button" class="relative inline-flex items-center px-4 py-2 mt-4 text-sm font-medium leading-5 text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700">
                    Crea nuova categoria
                  </router-link>
-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="mt-2 text-xs text-gray-700">
          * I prezzi medi, minimi e massimi sono calcolati considerando i piatti
          con prezzo espresso in € (non €/kg...)
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryService from "../apis/CategoryService";
import draggable from "vuedraggable";
import IconService from "../apis/IconService";

export default {
  props: {
    id: Number,
  },
  components: {
    draggable,
  },
  data() {
    return {
      categories: [],
      showEmpty: false,
      disabled: false,
      action: this.$route.meta.action,
      options: {
        delay: 200,
        touchStartThreshold: 5,
        delayOnTouchOnly: true,
      },
    };
  },
  mounted() {
    CategoryService.getCategories(this.id).then((response) => {
      this.categories = response.data.data;
      if (this.categories.length == 0) {
        this.showEmpty = true;
      }
    });
  },
  created() {},
  methods: {
    goTo(categoryid) {
      this.$router.push({
        name: "Category",
        params: { id: this.id, idcategory: categoryid },
      });
    },

    getCategoryIcon: function(url) {
      return IconService.getIconCat(url);
    },

    onDraggableUpdate() {
      this.$store.dispatch("updateSpinner", true);

      this.disabled = true;

      CategoryService.updatePositions(this.id, { categories: this.categories })
        .then((response) => {
          console.log(response.data);
        })
        .finally(() => {
          this.disabled = false;
          this.$store.dispatch("updateSpinner", false);
        });
    },
  },
};
</script>
